import React, { useState, useRef, useEffect } from 'react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isAcademicsOpen, setIsAcademicsOpen] = useState(false);
  const [isDesktopAboutOpen, setIsDesktopAboutOpen] = useState(false);
  const [isDesktopAcademicsOpen, setIsDesktopAcademicsOpen] = useState(false);

  // Refs for click‑outside detection
  const mobileMenuRef = useRef(null);
  const desktopAboutRef = useRef(null);
  const desktopAcademicsRef = useRef(null);

  // Toggle functions
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleAbout = () => setIsAboutOpen(!isAboutOpen);
  const toggleAcademics = () => setIsAcademicsOpen(!isAcademicsOpen);
  const toggleDesktopAbout = () => setIsDesktopAboutOpen(!isDesktopAboutOpen);
  const toggleDesktopAcademics = () => setIsDesktopAcademicsOpen(!isDesktopAcademicsOpen);

  // Close all menus when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close mobile menu if open and click outside
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && isMenuOpen) {
        setIsMenuOpen(false);
      }
      // Close desktop About dropdown if open and click outside
      if (desktopAboutRef.current && !desktopAboutRef.current.contains(event.target) && isDesktopAboutOpen) {
        setIsDesktopAboutOpen(false);
      }
      // Close desktop Academics dropdown if open and click outside
      if (desktopAcademicsRef.current && !desktopAcademicsRef.current.contains(event.target) && isDesktopAcademicsOpen) {
        setIsDesktopAcademicsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen, isDesktopAboutOpen, isDesktopAcademicsOpen]);

  return (
    <div>
      {/* Top Bar - Social Media Links */}
      <div className="bg-blue-600 text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row justify-between items-center text-sm">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <span>+91 7275370808</span>
              <span>rdscollege0342@gmail.com</span>
            </div>
            {/* Social Media Links */}
            <div className="flex gap-4 mt-2 sm:mt-0">
              <a 
                href="https://www.facebook.com/rdspharmacy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-blue-200 transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/rdsgroup_of_colleges?igsh=MTNma2x6cTBwdGJwdA==" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-blue-200 transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153.509.5.881 1.105 1.153 1.772.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428-.254.66-.598 1.216-1.153 1.772-.5.509-1.105.881-1.772 1.153-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465-.66-.254-1.216-.598-1.772-1.153-.509-.5-.881-1.105-1.153-1.772-.247-.637-.415-1.363-.465-2.428-.047-1.066-.06-1.405-.06-4.122 0-2.717.01-3.056.06-4.122.05-1.065.218-1.79.465-2.428.254-.66.598-1.216 1.153-1.772.5-.509 1.105-.881 1.772-1.153.637-.247 1.363-.415 2.428-.465C8.944 2.01 9.283 2 12 2zm0 5a5 5 0 100 10 5 5 0 000-10zm6.5-.25a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM12 9a3 3 0 110 6 3 3 0 010-6z"/>
                </svg>
              </a>
              <a 
                href="https://youtube.com/@rdscollegeofpharmacy8349?si=Onm4n5PHvFADYa4q" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-blue-200 transition-colors"
                aria-label="YouTube"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M21.58 7.19c-.23-.86-.91-1.54-1.77-1.77C18.25 5 12 5 12 5s-6.25 0-7.81.42c-.86.23-1.54.91-1.77 1.77C2 8.75 2 12 2 12s0 3.25.42 4.81c.23.86.91 1.54 1.77 1.77C5.75 19 12 19 12 19s6.25 0 7.81-.42c.86-.23 1.54-.91 1.77-1.77C22 15.25 22 12 22 12s0-3.25-.42-4.81zM10 15V9l5 3-5 3z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-3">
            {/* Logo and College Name */}
            <div className="flex items-center gap-3">
              <img 
                src="/logo.jpeg" 
                alt="College Logo" 
                className="h-16 w-auto"
              />
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-6">
              <a href="/" className="text-gray-700 hover:text-blue-600 font-medium">
                Home
              </a>
              
              {/* About Dropdown (state‑controlled) */}
              <div className="relative" ref={desktopAboutRef}>
                <button 
                  onClick={toggleDesktopAbout}
                  className="text-gray-700 hover:text-blue-600 font-medium py-2 focus:outline-none"
                >
                  About
                </button>
                {isDesktopAboutOpen && (
                  <div className="absolute bg-white shadow-lg rounded-lg w-48 mt-2">
                    <a href="/about" className="block px-4 py-2 text-gray-700 hover:bg-blue-50">
                      About Us
                    </a>
                    <a href="/mission-vision" className="block px-4 py-2 text-gray-700 hover:bg-blue-50">
                      Mission & Vision
                    </a>
                    <a href="/principal-message" className="block px-4 py-2 text-gray-700 hover:bg-blue-50">
                      Principal Message
                    </a>
                  </div>
                )}
              </div>

              {/* Academics Dropdown (state‑controlled) */}
              <div className="relative" ref={desktopAcademicsRef}>
                <button 
                  onClick={toggleDesktopAcademics}
                  className="text-gray-700 hover:text-blue-600 font-medium py-2 focus:outline-none"
                >
                  Academics
                </button>
                {isDesktopAcademicsOpen && (
                  <div className="absolute bg-white shadow-lg rounded-lg w-48 mt-2">
                    <a href="/principal-message" className="block px-4 py-2 text-gray-700 hover:bg-blue-50">
                      Principal Message
                    </a>
                    <a href="/admissions" className="block px-4 py-2 text-gray-700 hover:bg-blue-50">
                      Admissions
                    </a>
                    <a href="/courses" className="block px-4 py-2 text-gray-700 hover:bg-blue-50">
                      Courses
                    </a>
                    <a href="/faculty" className="block px-4 py-2 text-gray-700 hover:bg-blue-50">
                      Faculty
                    </a>
                  </div>
                )}
              </div>

              <a href="/courses" className="text-gray-700 hover:text-blue-600 font-medium">
                Courses
              </a>
              <a href="/news" className="text-gray-700 hover:text-blue-600 font-medium">
                News
              </a>
              <a href="/downloads" className="text-gray-700 hover:text-blue-600 font-medium">
                Downloads
              </a>
              <a href="/gallery" className="text-gray-700 hover:text-blue-600 font-medium">
                Gallery
              </a>
              <a href="/contact-section" className="text-gray-700 hover:text-blue-600 font-medium">
                Contact
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={toggleMenu}
              className="md:hidden text-gray-700 focus:outline-none"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div ref={mobileMenuRef} className="md:hidden py-4 border-t">
              <a href="/" className="block py-2 text-gray-700 hover:text-blue-600">
                Home
              </a>
              
              {/* Mobile About Dropdown */}
              <div>
                <button 
                  onClick={toggleAbout}
                  className="w-full text-left py-2 text-gray-700 hover:text-blue-600 flex justify-between items-center"
                >
                  About
                  <svg className={`w-4 h-4 transition-transform ${isAboutOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isAboutOpen && (
                  <div className="pl-4 space-y-2">
                    <a href="/about" className="block py-2 text-gray-600 hover:text-blue-600">
                      About Us
                    </a>
                    <a href="/mission-vision" className="block py-2 text-gray-600 hover:text-blue-600">
                      Mission & Vision
                    </a>
                    <a href="/principal-message" className="block py-2 text-gray-600 hover:text-blue-600">
                      Principal Message
                    </a>
                  </div>
                )}
              </div>

              {/* Mobile Academics Dropdown */}
              <div>
                <button 
                  onClick={toggleAcademics}
                  className="w-full text-left py-2 text-gray-700 hover:text-blue-600 flex justify-between items-center"
                >
                  Academics
                  <svg className={`w-4 h-4 transition-transform ${isAcademicsOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isAcademicsOpen && (
                  <div className="pl-4 space-y-2">
                    <a href="/principal-message" className="block py-2 text-gray-600 hover:text-blue-600">
                      Principal Message
                    </a>
                    <a href="/admissions" className="block py-2 text-gray-600 hover:text-blue-600">
                      Admissions
                    </a>
                    <a href="/courses" className="block py-2 text-gray-600 hover:text-blue-600">
                      Courses
                    </a>
                    <a href="/faculty" className="block py-2 text-gray-600 hover:text-blue-600">
                      Faculty
                    </a>
                  </div>
                )}
              </div>

              <a href="/courses" className="block py-2 text-gray-700 hover:text-blue-600">
                Courses
              </a>
              <a href="/news" className="block py-2 text-gray-700 hover:text-blue-600">
                News
              </a>
              <a href="/downloads" className="block py-2 text-gray-700 hover:text-blue-600">
                Downloads
              </a>
              <a href="/gallery" className="block py-2 text-gray-700 hover:text-blue-600">
                Gallery
              </a>
              <a href="/contact-section" className="block py-2 text-gray-700 hover:text-blue-600">
                Contact
              </a>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;